import React, { useContext } from 'react';
import { store } from './reducer';
import Accordion from '../../../../../components/Accordion/Accordion';
import { isMobile } from 'react-device-detect';
import { makeStyles } from '@material-ui/core/styles';
import DatePicker from '../../../../../components/TextFields/DatePicker';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr 5fr',
    gridGap: theme.spacing(1),
  },
}));

const Filters = () => {
  const classes = useStyles();
  const {
    state: {
      filters: { start, end },
    },
    dispatch,
  } = useContext(store);

  const handleChangeStartDate = (date) => {
    dispatch({ type: 'CHANGE_START_DATE', payload: date });
  };
  const handleChangeEndDate = (date) => {
    dispatch({ type: 'CHANGE_END_DATE', payload: date });
  };

  return (
    <Accordion title="فیلترها" open={isMobile ? false : true}>
      <div className={classes.root}>
        <DatePicker
          label="ازتاریخ"
          value={start}
          onChange={handleChangeStartDate}
        />
        <DatePicker
          label="تا‌تاریخ"
          value={end}
          onChange={handleChangeEndDate}
        />
        {!isMobile && <div></div>}
      </div>
    </Accordion>
  );
};

export default React.memo(Filters);
